import { render } from "./auth-register.vue?vue&type=template&id=34a36efa&scoped=true"
import script from "./auth-register.vue?vue&type=script&lang=js"
export * from "./auth-register.vue?vue&type=script&lang=js"

import "./auth-register.vue?vue&type=style&index=0&id=34a36efa&scoped=true&lang=css"

import exportComponent from "C:\\active-project\\NeginPostClub\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34a36efa"]])

export default __exports__